import '../scss/customer.scss';
import '../utils/loginFormSwitcher';
import { passwordRevealer } from '../components/passwordField';
import {
  validateMatchingPasswords,
  validationFutureDate,
} from '../utils/passwordValidator';
import { registerLanguageTag } from '../components/registerLanguageTag';

registerLanguageTag();
passwordRevealer('#login-password-button', '#login-password');
passwordRevealer('#register-password-button', '#register-password');
passwordRevealer(
  '#register-password-confirmation-button',
  '#register-password-confirmation'
);
validateMatchingPasswords('#create_customer_submit', '#create_customer');
validationFutureDate();
